import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../../../components/ui/alert-dialog';

interface UnpublishProjectDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  projectTitle: string;
  onConfirm: () => void;
  isUnpublishing: boolean;
}

export function UnpublishProjectDialog({
  open,
  onOpenChange,
  projectTitle,
  onConfirm,
  isUnpublishing,
}: UnpublishProjectDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Unpublish Practice Project?</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to unpublish <strong>"{projectTitle}"</strong>? 
            This will hide the project from students, but existing enrollments will remain intact.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isUnpublishing}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={isUnpublishing}
            className="bg-orange-600 hover:bg-orange-700"
          >
            {isUnpublishing ? 'Unpublishing...' : 'Unpublish'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
